import { Box } from "@mui/material";

export default function AdminAppContainer({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        paddingLeft: "48px",
        alignItems: "flex-start",
        alignSelf: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "16px",
          gap: "16px",
          flex: "1 0 0",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
